import { render, staticRenderFns } from "./orgDetail.vue?vue&type=template&id=66a3ece4&scoped=true&"
import script from "./orgDetail.vue?vue&type=script&lang=js&"
export * from "./orgDetail.vue?vue&type=script&lang=js&"
import style0 from "./orgDetail.vue?vue&type=style&index=0&id=66a3ece4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a3ece4",
  null
  
)

export default component.exports